export default __webpack_public_path__ + "static/poweredby-4-664c551173897dbb581cae4176655dab.webm";